// types
import { DefaultConfigProps } from 'types/config';
import { clacUiGlobal } from 'utils/uiGlobal';

// ==============================|| THEME CONSTANT ||============================== //

export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/terceros';
export const HORIZONTAL_MAX_ITEM = 8;
// TODO: definir URL real del centro de ayuda (ver NavUser.tsx)
export const HELP_URL = '';
export const SUPPORT_TICKET_URL = (import.meta.env.VITE_CLAC_URL_SOPORTE ?? '').trim();
export const DRAWER_WIDTH = clacUiGlobal.layout.sidebarWidth;
export const MINI_DRAWER_WIDTH = clacUiGlobal.layout.sidebarWidthMini;
export const HEADER_HEIGHT = clacUiGlobal.layout.brandHeight;
// Alto que descuenta el contenido: topbar fijo + su spacer. Medido sobre el layout actual.
export const CONTENT_OFFSET = clacUiGlobal.layout.topbarHeight * 2 + 4;
export const GRID_COMMON_SPACING = { xs: 2, md: 2.5 };

export enum SimpleLayoutType {
  SIMPLE = 'simple',
  LANDING = 'landing'
}

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
  AUTO = 'auto'
}

export enum MenuOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}

export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl'
}

export enum NavActionType {
  FUNCTION = 'function',
  LINK = 'link'
}

export enum Gender {
  MALE = 'Male',
  FEMALE = 'Female'
}

export enum DropzopType {
  DEFAULT = 'default',
  STANDARD = 'standard'
}

// ==============================|| THEME CONFIG ||============================== //

const config: DefaultConfigProps = {
  fontFamily: clacUiGlobal.fonts.families.body,
  i18n: 'es',
  menuOrientation: MenuOrientation.VERTICAL,
  menuCaption: true,
  miniDrawer: false,
  container: true,
  mode: ThemeMode.LIGHT,
  presetColor: 'clac',
  themeDirection: ThemeDirection.LTR,
  themeContrast: false
};

export default config;
